import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'
import { GQL_QUERY_CURRENT_BRAND_INFO } from '@@partner:graphql/query/brand/currentBrandInfo.gql'

export interface BrandFile {
  key: string
  file_id: GQL_ID
  name: string
  fileSize?: number
  addedAt: string
  file?: {
    url: string
  }
}

export interface SetBrandFileResult {
  setBrandFile: {
    id: GQL_ID
    brandFiles: BrandFile[]
  }
}

export interface SetBrandFileVariables {
  key: string
  file_id: number
  name?: string
}

export const GQL_MUTATION_SET_BRAND_FILE = gql`
  mutation SetBrandFile($key: String!, $file_id: Int!, $name: String) {
    setBrandFile(key: $key, file_id: $file_id, name: $name) {
      id
      brandFiles {
        key
        file_id
        name
        fileSize
        addedAt
        file {
          url
        }
      }
    }
  }
`

export const useSetBrandFile = () => {
  return useMutation<SetBrandFileResult, SetBrandFileVariables>(
    GQL_MUTATION_SET_BRAND_FILE,
    {
      refetchQueries: [ { query: GQL_QUERY_CURRENT_BRAND_INFO } ]
    }
  )
}
